export const contactsData = {
    email: 'hannandev01@gmail.com',
    phone: '+92440757001',
    address: 'E-block Johar Town Lahore',
    github: 'https://github.com/HannanShehzad',
    facebook: 'https://www.facebook.com/profile.php?id=100006209267896',
    linkedIn: 'www.linkedin.com/in/hannan-shehzad-767667201',
    twitter: 'https://twitter.com/Hannan_Shehzad',
    medium: 'https://wa.me/+923440757001',
    stackOverflow: '#',
    devUsername: "#"
}